module.exports = __webpack_public_path__ + "Roboto-MediumItalic.eb65fb18d4446e4ac27d.svg";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-MediumItalic.svg
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-MediumItalic.svg
// module chunks = 13